package org.ssoft.common.tools


import kotlinx.datetime.*
import kotlin.time.Clock
import kotlin.time.Duration
import kotlin.time.Duration.Companion.milliseconds


fun Clock.Companion.nowDateTime() = Clock.System.now()
    .toLocalDateTime(TimeZone.currentSystemDefault())

fun Clock.Companion.nowMilliseconds() = Clock.System.now().toEpochMilliseconds()

fun Clock.Companion.nowDuration() = nowMilliseconds().milliseconds

/** 00:00 */
val LocalTime.Companion.EMPTY get() = LocalTime(0, 0, 0)

/** 0001-01-01 */
val LocalDate.Companion.EMPTY get() = LocalDate(1, 1, 1)

/** 0001-01-01T00:00 */
val LocalDateTime.Companion.EMPTY get() = LocalDateTime(LocalDate.EMPTY, LocalTime.EMPTY)

/** 23:59 */
val LocalTime.Companion.MAX get() = LocalTime(23, 59)

/** 00:00 */
val LocalTime.Companion.MIN get() = LocalTime(0, 0)

fun Clock.Companion.nowDate() = nowDateTime().date

fun LocalDate.copy(): LocalDate = LocalDate.fromEpochDays(toEpochDays())

operator fun Duration.rem(other: Duration): Duration {
    return (inWholeMilliseconds % other.inWholeMilliseconds).milliseconds
}

operator fun LocalDate.plus(time: LocalTime): LocalDateTime {
    return LocalDateTime(copy(), time)
}

expect val UtcOffset.Companion.SYSTEM: UtcOffset
//val UtcOffset.Companion.SYSTEM get() =  UtcOffset(minutes = -Date().getTimezoneOffset() )

operator fun LocalDateTime.plus(value: Duration): LocalDateTime {
    return (toInstant(TimeZone.currentSystemDefault()) + value)
        .toLocalDateTime(TimeZone.currentSystemDefault())
}

operator fun LocalDateTime.minus(value: Duration): LocalDateTime {
    return (toInstant(TimeZone.currentSystemDefault()) - value)
        .toLocalDateTime(TimeZone.currentSystemDefault())
}